import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';
import { EditVideoAttributeInteractionFormsSections } from './types';

export function editAttributesInteractionFormsEvent({
  changedFieldKeys = [],
  changes = {},
  section,
}: {
  section: EditVideoAttributeInteractionFormsSections;
  changedFieldKeys: string[];
  changes: Record<string, any>;
}) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.EDIT_VIDEO_ATTRIBUTES_CHANGED_FORMS,
  };

  pushToDataLayer({
    ...eventAttributes,
    section,
    changed_fields: changedFieldKeys.length > 0 ? changedFieldKeys : undefined,
    ...changes,
  });
}
